import { createApp } from 'vue';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import '@/common/http/request';
import { debounce } from 'lodash';
import { VxeTable, VxeColumn, VxeGrid } from 'vxe-table';
import 'vxe-table/es/style.css';
import 'vxe-pc-ui/lib/style.css';
import App from '@/App.vue';
import { router } from '@/router/index';
import pinia from '@/store';
import useStaticDictStore from '@/store/staticDict';
import { VxeUI, VxeButton, VxeButtonGroup, VxeCard, VxeCheckbox, VxeCheckboxButton, VxeCheckboxGroup, VxeCol, VxeIcon, VxeIconPicker, VxeInput, VxeLoading, VxeModal, VxePager, VxeRadio, VxeRadioButton, VxeRadioGroup, VxeRow, VxeNumberInput, } from 'vxe-pc-ui';
// 导入主题变量，也可以重写主题变量
import 'vxe-pc-ui/styles/cssvar.scss';
// import 'vxe-table/styles/cssvar.scss'
// 导入默认的语言
import zhCN from 'vxe-pc-ui/lib/language/zh-CN.js';
VxeUI.setI18n('zh-CN', zhCN);
VxeUI.setLanguage('zh-CN');
VxeUI.component(VxeButton);
VxeUI.component(VxeButtonGroup);
VxeUI.component(VxeCard);
VxeUI.component(VxeCheckbox);
VxeUI.component(VxeCheckboxButton);
VxeUI.component(VxeCheckboxGroup);
VxeUI.component(VxeCol);
VxeUI.component(VxeIcon);
VxeUI.component(VxeIconPicker);
VxeUI.component(VxeInput);
VxeUI.component(VxeLoading);
VxeUI.component(VxeModal);
VxeUI.component(VxePager);
VxeUI.component(VxeRadio);
VxeUI.component(VxeRadioButton);
VxeUI.component(VxeRadioGroup);
VxeUI.component(VxeRow);
VxeUI.component(VxeNumberInput);
// 表格样式
import 'vxe-table/lib/style.css';
// layui样式
import '@layui/layui-vue/lib/index.css';
// vant样式
import 'vant/lib/index.css';
// element-plus 按需导入缺少的样式
import 'element-plus/theme-chalk/el-loading.css';
import 'element-plus/theme-chalk/el-message.css';
import 'element-plus/theme-chalk/el-message-box.css';
import 'element-plus/theme-chalk/el-notification.css';
import 'element-plus/theme-chalk/el-cascader.css';
import 'element-plus/theme-chalk/el-cascader-panel.css';
import 'element-plus/theme-chalk/el-tree.css';
import 'element-plus/theme-chalk/el-date-picker.css';
import 'element-plus/theme-chalk/el-date-picker-panel.css';
import 'element-plus/theme-chalk/el-input-number.css';
import 'element-plus/theme-chalk/el-switch.css';
import 'element-plus/theme-chalk/el-select.css';
// 其它样式
import '@/assets/online-icon/iconfont.css';
// 静态字典
import * as staticDict from '@/common/staticDict/index';
// 导入plus-pro-components 及其样式
import PlusProComponents from 'plus-pro-components';
import 'plus-pro-components/index.css';
import ElementPlus from 'element-plus';
// vxe-table设置
function useTable(app) {
    app.use(VxeTable).use(VxeColumn);
    app.use(VxeGrid).use(VxeColumn);
}
// 静态字典设置
function useStaticDict(app, staticDict) {
    if (app.config.globalProperties.StaticDict == null) {
        app.config.globalProperties.StaticDict = {};
    }
    Object.keys(staticDict).forEach(key => {
        app.config.globalProperties.StaticDict[key] = staticDict[key];
    });
}
// webpack需要重写ResizeObserver，否则会报错
const resizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends resizeObserver {
    constructor(callback) {
        callback = debounce(callback, 10);
        super(callback);
    }
};
const app = createApp(App);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component);
}
useStaticDict(app, staticDict);
app.use(ElementPlus);
app.use(PlusProComponents);
app.use(pinia).use(router).use(useTable);
app.mount('#app');
// 设置静态字典
const staticDictStore = useStaticDictStore();
staticDictStore.setStaticDict(app.config.globalProperties.StaticDict);
